'use client';

import { createContext, useContext } from 'react'
import { useGetListPropertiesCompany } from '@src/apis/list-listing/query';
import { useParams } from 'next/navigation'

const HomepageCtx = createContext();

export const HomepageProvider = ({ children, slug, ...detail }) => {
  const { companySlug } = useParams()

  const { data: listListing, isLoading } = useGetListPropertiesCompany({
    params: {
      property_category_ids: "1,2",
      grouping: true
    },
    slug: companySlug
  })

  return (
    <HomepageCtx.Provider value={{
      listListing,
      isLoading,
      slug
    }}>
      {children}
    </HomepageCtx.Provider>
  )
}


const useHomepageCtx = () => {
  const ctx = useContext(HomepageCtx);

  if (!ctx) {
    throw new Error("useHomepageCtx must be used within the HomepageProvider");
  }

  return ctx;
};


export default useHomepageCtx